module.exports = __webpack_public_path__ + "static/img/tableview.5117d3c2.png";